/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { MaterialMetricViewModel } from "../types/MaterialMetricViewModel.ts";

export const materialMetricViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  cultureInfo: z.string().nullish(),
  fileName: z.string().nullish(),
  numberOfDownloads: z.optional(z.number().int()),
}) as unknown as ToZod<MaterialMetricViewModel>;
